import { Box } from "@mui/material";

/**
 * Componente opcional para layout de formulários que não são filhos diretos de FForm.
 * Ex: Campos dentro de abas de formulário.
 */
export default function FormContent({ sx, children, ...props }) {
    return (
        <Box sx={{ 
            display: "flex", 
            flexDirection:'column', 
            flex: 1, 
            flexWrap: "wrap", 
            gap: { xs: 1.5, sm: 2, lg: 2.5 }, 
            ...sx 
        }}>
            {children}
        </Box>
    );
}
